// Product.js
export default class Product {
    constructor(
        names = {},
        descriptions = {},
        datasheets = {},
        photo = {},
        year = 0,
        position = 0,
        mainProductInfos = [] 
    ) {
        this.names = names;
        this.descriptions = descriptions;
        this.datasheets = datasheets;
        this.photo = photo;
        this.year = year;
        this.position = position;
        this.mainProductInfos = mainProductInfos;
    }

    // Make sure to include a validation method if needed
    isValid(currentLanguage) {
        let result = true;
        
        // Add necessary validation checks here
        if (!this.names[currentLanguage] || !this.names[currentLanguage].trim()) result = false;
        if (!this.descriptions[currentLanguage] || !this.descriptions[currentLanguage].trim()) result = false;
        
        // Ensure `mainProductInfos` is valid
        for (let info of this.mainProductInfos) {
            if (
                !info.keys || !info.keys[currentLanguage] || !info.keys[currentLanguage].trim() ||
                !info.values || !info.values[currentLanguage] || !info.values[currentLanguage].trim()
            ) {
                result = false;
                break;
            }
        }

        return result;
    }
}
